
/* injects from baggage-loader */
require('./quicksight-dashboard.component.html');

import angular from 'angular';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import './reports.scss';
import './quicksight-dashboard.component.scss';

angular.module('AaApp.Opp').component('quickSightDashboard', {
    templateUrl: '/app/components/reports/quicksight-dashboard.component.html',
    controller: QuickSightDashboardController,
});

/* @ngInject */
function QuickSightDashboardController($window, $document, $scope, $state, _, dealerService, reportService, storageService) {
    const $ctrl = this;

    let selectedDealerIdsSubscription = null;
    let dashboardRenderRequestId = 0;

    $ctrl.reportsEnabled = false;
    $ctrl.reportEnabled = true;
    $ctrl.embeddingDashboard = false;
    $ctrl.selectedDashboardId = null;
    $ctrl.selectedDashboardName = '';
    $ctrl.embedError = '';
    $ctrl.statusMessageKey = '';
    $ctrl.$onInit = onInit;
    $ctrl.$onDestroy = onDestroy;

    function onInit() {
        const moduleIds = storageService.getItem('moduleIds');
        const authorizedReports = reportService.getAuthorizedReports(moduleIds);
        $ctrl.reportsEnabled = authorizedReports.length > 0;
        if (!$ctrl.reportsEnabled) {
            return;
        }

        selectedDealerIdsSubscription = dealerService.onSelectedDealersChanged(function () {
            if ($ctrl.selectedDashboardId) {
                renderSelectedDashboard($ctrl.selectedDashboardId);
            }
        });

        const initialDashboardId = getDashboardIdFromState();
        if (!initialDashboardId) {
            $ctrl.reportEnabled = false;
            $ctrl.statusMessageKey = 'quickSightSelectReport';
            return;
        }

        $ctrl.selectedDashboardId = initialDashboardId;
        $ctrl.selectedDashboardName = getDashboardNameFromState() || initialDashboardId;
        renderSelectedDashboard(initialDashboardId);
    }

    function onDestroy() {
        if (selectedDealerIdsSubscription && selectedDealerIdsSubscription.unsubscribe) {
            selectedDealerIdsSubscription.unsubscribe();
        }
    }

    function getDashboardIdFromState() {
        if ($state && $state.params) {
            return $state.params.dashboardId || $state.params.id || '';
        }

        return '';
    }

    function getDashboardNameFromState() {
        if ($state && $state.params) {
            return $state.params.reportName || '';
        }

        return '';
    }

    async function renderSelectedDashboard(dashboardId) {
        const requestId = ++dashboardRenderRequestId;
        $ctrl.embeddingDashboard = true;
        $ctrl.embedError = '';
        $ctrl.statusMessageKey = '';

        try {
            const selectedDealerIds = dealerService.getSelectedDealerIds() || [];
            const selectedDealerIdList = selectedDealerIds.join(',');
            const reportUrl = buildReportUrl(dashboardId);
            const results = await reportService.getQuickSightEmbedUrl(dashboardId, selectedDealerIdList);

            if (requestId !== dashboardRenderRequestId) {
                return;
            }

            if (!results || results.Success !== true || !results.Data) {
                throw new Error(getQuickSightResponseMessage(results));
            }

            const embedUrl = getQuickSightEmbedUrlValue(results.Data);
            if (!embedUrl) {
                throw new Error(getQuickSightResponseMessage(results));
            }

            await embedDashboard(embedUrl, buildQuickSightParameters(results, reportUrl));
        } catch (error) {
            if (requestId !== dashboardRenderRequestId) {
                return;
            }

            $ctrl.embedError = getQuickSightErrorMessage(error);
            if (!$ctrl.embedError) {
                $ctrl.statusMessageKey = 'quickSightLoadError';
            }
        } finally {
            if (requestId === dashboardRenderRequestId) {
                $ctrl.embeddingDashboard = false;
            }
        }
    }

    async function embedDashboard(embedUrl, parameters) {
        const embeddingContext = await createEmbeddingContext();
        const embedHeight = getEmbedHeight();

        const container = $document[0].getElementById('quicksight-embed-container');
        if (container) {
            container.innerHTML = '';
            container.style.height = embedHeight;
        }

        await embeddingContext.embedDashboard({
            url: embedUrl,
            container: '#quicksight-embed-container',
            height: embedHeight,
            width: '100%'
        }, {
            locale: 'en-US',
            parameters: parameters,
            onMessage: function (messageEvent) {
                if (messageEvent && messageEvent.eventName === 'ERROR_OCCURRED') {
                    $scope.$applyAsync(function () {
                        const errorCode = messageEvent.message && messageEvent.message.errorCode;
                        $ctrl.embedError = errorCode
                            ? 'QuickSight error: ' + errorCode
                            : 'QuickSight reported an error while loading the report.';
                        $ctrl.statusMessageKey = '';
                    });
                }
            },
            toolbarOptions: {
                export: true,
                undoRedo: true,
                reset: true,
                bookmarks: true,
                thresholdAlerts: false,
                scheduling: true,
                recentSnapshots: false,
                executiveSummary: false
            }
        });
    }

    function getEmbedHeight() {
        const viewportHeight = $window.innerHeight || 900;
        return Math.max(viewportHeight - 180, 1400) + 'px';
    }

    function buildReportUrl(dashboardId) {
        return $window.location.host + '/reports/quickSightReports?id=' + encodeURIComponent(dashboardId);
    }

    function buildQuickSightParameters(results, reportUrl) {
        const userProfile = storageService.getItem('userProfile') || {};
        const data = results && results.Data && typeof results.Data === 'object' ? results.Data : {};
        const platformIdsValue = data.selectedAutoAlertPlatformIds != null
            ? data.selectedAutoAlertPlatformIds
            : data.SelectedAutoAlertPlatformIds;
        const platformIds = toQuickSightValues(platformIdsValue);
        const primaryRoleId = data.primaryRoleId != null
            ? data.primaryRoleId
            : data.PrimaryRoleId != null
                ? data.PrimaryRoleId
                : userProfile.roleId;
        const packages = toQuickSightValues(
            data.selectedAutoAlertDealerPackages || data.SelectedAutoAlertDealerPackages
        );

        if (platformIdsValue == null && angular.isArray(userProfile.accountPlatformIds)) {
            platformIds.push(...userProfile.accountPlatformIds.map(String));
        }

        return [
            {
                Name: 'selectedAutoAlertPlatformIds',
                Values: platformIds
            },
            {
                Name: 'primaryRoleId',
                Values: primaryRoleId == null ? [] : [String(primaryRoleId)]
            },
            {
                Name: 'selectedAutoAlertDealerPackages',
                Values: packages.map(String)
            },
            {
                Name: 'reportUrl',
                Values: [reportUrl]
            }
        ];
    }

    function toQuickSightValues(value) {
        if (angular.isArray(value)) {
            return value.map(String);
        }

        if (typeof value === 'string') {
            return value.split('|').filter(function (item) {
                return item !== '';
            }).map(String);
        }

        if (value == null) {
            return [];
        }

        return [String(value)];
    }

    function getQuickSightResponseMessage(results) {
        if (!results) {
            return '';
        }

        return coerceQuickSightMessage(results.Message)
            || coerceQuickSightMessage(results.message)
            || coerceQuickSightMessage(results.Messages)
            || coerceQuickSightMessage(results.messages)
            || coerceQuickSightMessage(results.Details)
            || '';
    }

    function getQuickSightEmbedUrlValue(data) {
        if (!data) {
            return '';
        }

        if (typeof data === 'string') {
            return data;
        }

        if (typeof data === 'object') {
            return data.Url
                || data.url
                || data.EmbededUrl
                || data.embededUrl
                || data.EmbedUrl
                || data.embedUrl
                || data.Value
                || data.value
                || coerceQuickSightMessage(data.Data)
                || '';
        }

        return coerceQuickSightMessage(data);
    }

    function getQuickSightErrorMessage(error) {
        if (!error) {
            return '';
        }

        if (error.message) {
            return error.message;
        }

        if (error.body) {
            return getQuickSightResponseMessage(error.body);
        }

        if (error.error) {
            return getQuickSightResponseMessage(error.error);
        }

        if (error.data) {
            return getQuickSightResponseMessage(error.data);
        }

        return getQuickSightResponseMessage(error);
    }

    function coerceQuickSightMessage(value) {
        if (!value) {
            return '';
        }

        if (typeof value === 'string') {
            return value;
        }

        if (typeof value === 'number' || typeof value === 'boolean') {
            return String(value);
        }

        if (angular.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                const itemMessage = coerceQuickSightMessage(value[i]);
                if (itemMessage) {
                    return itemMessage;
                }
            }

            return '';
        }

        if (typeof value === 'object') {
            return coerceQuickSightMessage(value.Message)
                || coerceQuickSightMessage(value.message)
                || coerceQuickSightMessage(value.ErrorMessage)
                || coerceQuickSightMessage(value.errorMessage)
                || coerceQuickSightMessage(value.Messages)
                || coerceQuickSightMessage(value.messages)
                || coerceQuickSightMessage(value.Details)
                || coerceQuickSightMessage(value.detail)
                || '';
        }

        return String(value);
    }
}
